const STAGES = {
  dependencies: "Checking dependencies",
  node_dependencies: "Checking or waiting for JavaScript dependencies",
  node_install: "Installing JavaScript dependencies",
  python_dependencies: "Checking or waiting for Python dependencies",
  python_install: "Installing Python dependencies",
  waiting_workspace: "Waiting for another session to finish workspace preparation",
  fetch: "Downloading repository updates",
  sync: "Updating the base repository",
  hooks: "Preparing project files",
  checkout: "Creating the session workspace",
  links: "Connecting shared assets and dependencies",
};
export const setupStageLabel = (stage) => STAGES[stage] || "Preparing workspace";
export function setupTimeRemaining(deadlineAt, now = Date.now()) {
  const seconds = Math.max(0, Math.ceil((Date.parse(deadlineAt) - now) / 1000));
  if (!Number.isFinite(seconds)) return "—";
  return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
}
